import { TImagesDataById, TImageTokenWithFile } from '@northladder/apis';

import { IDeviceImageOptions } from '../../types';

import { DeviceImageItem } from './DeviceImageItem';

interface IDeviceImagesCaptureAndUploadProps {
  /**
   * List of ids of the image, retrieved from the response images list.
   */
  imagesDataIds: string[];
  /**
   * Normalized object from the images list, by the image id.
   * This has been added to make updates to the image much faster.
   */
  imagesDataById: TImagesDataById;
  /**
   * The function to be called when the image is update, such as after a camera
   * take, a crop or upload success/fail.first-letter:This later updates the
   * images normalized list with this new info, such as image URL or status.
   */
  onUpdateImage: IDeviceImageOptions['onUpdateImage'];
}

/**
 * -----------------------------------------------------------------------------
 * Creates functionality for selecting, uploading and previewing the uploaded
 * image.
 */
export function DeviceImagesCaptureAndUpload({
  imagesDataIds,
  imagesDataById,
  onUpdateImage,
}: IDeviceImagesCaptureAndUploadProps) {
  const itemsCount = imagesDataIds.length;
  const rowItemsClass = `lg:grid-cols-${itemsCount}`;

  return (
    <section
      className={`
        grid grid-cols-1 flex-wrap gap-2 py-2 sm:grid-cols-2 sm:gap-x-2
        md:grid-cols-3 ${rowItemsClass}
      `}
    >
      {imagesDataIds.map((imageDataUrl) => (
        <DeviceImageItem
          key={imageDataUrl}
          imageData={imagesDataById[imageDataUrl] as TImageTokenWithFile}
          onUpdateImage={onUpdateImage}
        />
      ))}
    </section>
  );
}
